<template>
  <span class="ui-badge" :class="`ui-badge--${variant}`" :data-tone="tone ?? undefined">
    <slot />
  </span>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    variant?: "default" | "accent" | "danger";
    tone?: "travel" | "work" | "combat" | "econ" | "social" | null;
  }>(),
  {
    variant: "default",
    tone: null
  }
);
</script>

<style scoped>
.ui-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.4rem;
  padding: 0.1rem 0.5rem;
  border-radius: var(--radius-pill);
  font-size: 0.7rem;
  border: 1px solid transparent;
}

.ui-badge--default {
  background: color-mix(in srgb, var(--fg-1) 20%, transparent);
  border-color: color-mix(in srgb, var(--fg-1) 42%, transparent);
}

.ui-badge--accent {
  background: color-mix(in srgb, var(--accent) 18%, transparent);
  border-color: color-mix(in srgb, var(--accent) 56%, transparent);
}

.ui-badge--danger {
  background: color-mix(in srgb, var(--state-danger) 18%, transparent);
  border-color: color-mix(in srgb, var(--state-danger) 56%, transparent);
  color: var(--fg-0);
}

.ui-badge[data-tone="travel"] {
  --accent: var(--accent-travel);
}

.ui-badge[data-tone="work"] {
  --accent: var(--accent-work);
}

.ui-badge[data-tone="combat"] {
  --accent: var(--accent-combat);
}

.ui-badge[data-tone="econ"] {
  --accent: var(--accent-econ);
}

.ui-badge[data-tone="social"] {
  --accent: var(--accent-social);
}
</style>
